<template>
    <h3 class="!mb-0 text-lg">{{ name }}</h3>
    <span 
        class="text-base" 
        :class="subtitleColour"

        v-html="membershipTypes"
    />
</template>

<script setup>
    import { computed } from 'vue'
    import store from '@app/fac-search/state/store'
	import dayjs from 'dayjs'

    const props = defineProps({
        membership     : Object,
        subtitleColour : {
            type    : String,
            default : 'text-sub-old'
        }
    })

    const memberType = computed(() => store.data.fac_type_memberships.getMemberType(props.membership))

    const name = computed(
        () => memberType.value.type === 'individual'
            ? `${memberType.value.forename} ${memberType.value.surname}`
            : memberType.value.name
    )

    const isRegister = computed(
        () => store.data.fac_type.details.value.slug === 'register'
    )

    const membershipTypes = computed(
        () => Object.values(props.membership?.membership_types ?? []).map(getMembershipTypeLabel).join(', ') ?? ''
    )

    const getMembershipTypeLabel = (type) => {
        const label = type.on_practice_break
            ? `${type.certificate_title?.label ?? type.name} <span class="text-sm">(on practice break)</span>`
            : (type.certificate_title?.label ?? type.name)

        if(!isRegister.value){
            return label
        }

        return `${label} <span class="text-sm">(renewal date: ${dayjs(type.expiry_date, 'YYYY-MM-DD').format('DD/MM/YYYY')})</span>`
    }
</script>